export default __webpack_public_path__ + "static/media/scoreImage-mob.abe55dd4.png";